import get from "lodash/get";

export const getSearchPageItems = async (slug, offset, limit) => {
  const { results } = await (await fetch(`/api/v1/search?q=${slug}&offset=${offset}&limit=${limit + 1}`)).json();
  const loadMoreStories = results.stories.map((story) => {
    return { type: "story", story: story };
  });
  return loadMoreStories;
};

export const getStories = async (query, slug, offset, limit) => {
  const { stories } = await (
    await fetch(`/api/v1/stories?${query}=${slug}&offset=${offset}&limit=${limit + 1}`)
  ).json();
  const loadMoreStories = stories.map((story) => {
    return { type: "story", story: story };
  });
  return loadMoreStories;
};

export const getCollectionitems = async (slug, offset, limit) => {
  const { items } = await (
    await fetch(`/api/v1/collections/${slug}?&item-type=story&offset=${offset}&limit=${limit + 1}`)
  ).json();
  return items;
};

export const getAuthorStories = async (id, offset, limit) => {
  const { items } = await (
    await fetch(`/api/v1/authors/${id}/collection?&item-type=story&offset=${offset}&limit=${limit}`)
  ).json();
  return items;
};

export function getAdvancedSearchOfStories(queryParams) {
  return global
    .wretch()
    .url("/api/v1/advanced-search")
    .query({
      ...queryParams,
    })
    .get()
    .json((response) => response);
}
export function getAdvancedSearchAuthor(queryParams) {
  return global
    .wretch()
    .url("/api/v1/authors")
    .query({
      ...queryParams,
    })
    .get()
    .json((response) => response);
}

export const getLinkedStory = (element, story) => {
  const linkedStoryId = get(element, ["metadata", "linked-story", "id"], "");
  const linkedStory = get(story, ["linked-stories", linkedStoryId], {});
  const linkedStorySlug = get(story, ["linked-stories", linkedStoryId, "url"], "");

  return { linkedStory, linkedStorySlug };
};
